import * as Net from 'util/Net';

export function createAgentFoundry(name: string, description: string): Promise<{agentFoundryId: string}> {
  return Net.postJSONPromise({url: '/1/api/llm/agent-foundries', data: {name, description}});
}
